export const SOCIAL_PLATFORMS = [
  'instagram',
  'tiktok',
  'youtube',
  'linkedin',
  'facebook',
  'x',
  'telegram',
] as const;

export type SocialPlatformType = (typeof SOCIAL_PLATFORMS)[number];

export const PLATFORM_CAPTION_LIMITS: Record<SocialPlatformType, number> = {
  instagram: 2200,
  tiktok: 2200,
  youtube: 5000,
  linkedin: 3000,
  facebook: 63206,
  x: 280,
  telegram: 1024,
};

export const PLATFORM_REQUIRES_TITLE: Record<SocialPlatformType, boolean> = {
  instagram: false,
  tiktok: false,
  youtube: true,
  linkedin: false,
  facebook: false,
  x: false,
  telegram: false,
};

// Platforms whose API accepts an auto-posted first comment (Zernio
// `platformSpecificData.firstComment`). TikTok has no comment API; Telegram
// posts one channel message with no separate comment concept. X accepts a
// threaded reply as the first comment (confirm Zernio support on first sync).
export const PLATFORM_SUPPORTS_FIRST_COMMENT: Record<SocialPlatformType, boolean> = {
  instagram: true,
  tiktok: false,
  youtube: true,
  linkedin: true,
  facebook: true,
  x: true,
  telegram: false,
};
